import { CommandButton, FooterMenu, HeaderMenu } from "components"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { TabProfile } from "./TabProfile"
import { TabNavTransaction } from "../components/TabNavTransaction"
import { TabTransactionPath } from "../types"
import { useState } from "react"
import { TabBoq } from "./TabBoq"
import { TabTransaction } from "./TabTransaction"
import { TabDashboard } from "./TabDashboard"
import { TabTask } from "./TabTask"
import { TabResources } from "./TabResources"
import { TabAddress } from "./TabAddress"
import { TabEmedia } from "./TabEmedia"
import { TabChecklist } from "./TabChecklist"
// import { useState } from "react"

type TabsSearchParams = {
    tabs: TabTransactionPath
}


export default function EditProject() {
    const { id } = useParams<{ id: string }>()
    const [searchParams, setSearchParams] = useSearchParams({ tabs: "profile" } as TabsSearchParams)
    const [projectCode, setProjectCode] = useState('')
    const activeTab = searchParams.get("tabs")
    const setActiveTab = (path: string) => setSearchParams({ tabs: path })
    let disablePath = [""]
    const navigate = useNavigate()

    const isEdit = Boolean(id)


    return (
        <section className="container my-5">
            <HeaderMenu title="PROJECT"  action={isEdit? 'edit':'view'} className="sticky top-[0px] z-[1]" >
                <div>{projectCode}</div>
            </HeaderMenu>
            <TabNavTransaction activeTab={activeTab!} setActiveTab={setActiveTab} disablePath={disablePath}/>
            {activeTab === "profile" && <TabProfile setProjectCode={setProjectCode} action={isEdit? 'edit':'view'} project_id={String(id!)}/>}
            {activeTab === "boq" && <TabBoq  action={isEdit? 'edit':'view'} project_id={String(id!)} />}
            {activeTab === "checklist" && <TabChecklist  action={isEdit? 'edit':'view'} project_id={String(id!)} />}
            {activeTab === "transaction" && <TabTransaction  action={'edit'} project_id={String(id!)} />}
            {activeTab === "dashboard" && <TabDashboard  action={'edit'} project_id={String(id!)} />}
            {activeTab === "task" && <TabTask  action={'edit'} project_id={String(id!)} />}
            {activeTab === "resources" && <TabResources  action={'edit'} project_id={String(id!)} />}
            {activeTab === "address" && <TabAddress  action={'edit'} project_id={String(id!)} />}
            {activeTab === "emedia" && <TabEmedia  action={'edit'} project_id={String(id!)} />}

            
            <FooterMenu
                customRightElement={
                        <CommandButton
                        type="button"
                        actiontype="cancel"
                        onClick={() => {
                            navigate("/project")
                        }}
                    />
                }
                customElement={{
                    journal:<></>,
                    print: <></>,
                }}
            />
               
        </section>
    )
}